import {
  all,
  call,
  fork,
  put,
  select,
  delay,
  takeEvery,
  takeLatest,
} from "redux-saga/effects";
import {
  APP_INITIALIZE,
  FILTER_CHANGE,
  FILTER_MOUNTED,
  FILTER_RESET,
  FILTERS_MOUNTED,
  QUERY_CHANGE,
} from "actions/const";
import { fetchResultAsync } from "./search";
import * as queryUtils from "utils/query";
import * as filterUtils from "utils/filter";
import * as selectors from "./selectors";
import history from "../history";
import config from "config";
import { CHANGE_TYPES } from "constants/search";

let filterStates = {};

function* combineFilterStates(action) {
  const filters = yield select(selectors.getFilters);

  if (
    filters[action.name] &&
    filters[action.name].isMounted === action.mounted
  ) {
    return false;
  }

  filterStates = {
    ...filterStates,
    ...{
      [action.name]: {
        isMounted: action.mounted,
      },
    },
  };

  return filterStates;
}

function* updateUrlQueryString(action) {
  // debounce filter selection
  yield delay(200);
  if (!config.enableUrlQuery) {
    return;
  }
  let urlQueryObj = queryUtils.fromQuery(history.location.search);

  switch (action.type) {
    case QUERY_CHANGE:
      urlQueryObj = {};
      urlQueryObj[action.name] = action.value;
      break;

    case FILTER_CHANGE:
      if (action.values && action.values.length) {
        urlQueryObj[action.name] = action.values;
      } else {
        delete urlQueryObj[action.name];
      }
      break;
    case FILTER_RESET:
      Object.keys(urlQueryObj).forEach((key) => {
        if (key !== filterUtils.getQueryFilterName()) {
          delete urlQueryObj[key];
        }
      });
      break;
  }
  history.push({
    path: location.pathname,
    search: queryUtils.toQuery(urlQueryObj),
  });
}

function* updateMountedState(filters) {
  yield delay(500);
  yield put({ type: FILTERS_MOUNTED, filters });
}

function* aggregateMountedStates(action) {
  const newFilterStates = yield call(combineFilterStates, action);

  if (!newFilterStates) {
    return;
  }
  const updateTask = yield fork(updateMountedState, newFilterStates);
  const cancelUpdate = () => {
    updateTask.cancel();
  };

  yield fork(takeLatest, FILTER_MOUNTED, cancelUpdate);
}

// watcher
export function* watchFilterChange() {
  let filterEffects = [
    takeLatest(FILTER_CHANGE, updateUrlQueryString),
    takeLatest(FILTER_CHANGE, fetchResultAsync, "replace", CHANGE_TYPES.FILTER),
    takeLatest(FILTER_RESET, updateUrlQueryString),
    takeLatest(FILTER_RESET, fetchResultAsync, "replace", CHANGE_TYPES.FILTER),
    takeLatest(QUERY_CHANGE, updateUrlQueryString),
    takeLatest(QUERY_CHANGE, fetchResultAsync, "replace", CHANGE_TYPES.QUERY),
    takeEvery(FILTER_MOUNTED, aggregateMountedStates),
  ];

  if (!config.skipInitalSearch) {
    filterEffects.push(
      takeLatest(
        APP_INITIALIZE,
        fetchResultAsync,
        "replace",
        CHANGE_TYPES.INITIALIZE,
      ),
    );
  }
  yield all(filterEffects);
}
